export default {"src":"/_next/static/media/facebook-icon.0926d684.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};